import React from 'react';
import PropTypes from 'prop-types';

export default class FieldError extends React.Component {
  render() {
    return (
      <div>
        <span style={{ display: "inline" }} data-mount="errors" className="sb-field-invalid-feedback">
          {this.props.errorMessage}
        </span>
      </div>
    );
  }
}

FieldError.propTypes = {
  errorMessage: PropTypes.string.isRequired
};
